import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel, CarouselContent, CarouselNext, CarouselPrevious, CarouselSlidePagination, CarouselSlot, Stack, TextAlpha, ConditionalWrapper, } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import compareActions from '../../redux/compare/actions/CompareActions.creators';
import { productGroupActions } from '../../redux/productGroup/actions/ProductGroupActions.creators';
import { wishListActions } from '../../redux/wishList/actions/WishListActions.creators';
import { generateTestId } from '../../util/TestUtil';
import { getSlideSizeWithGap } from '../carousel/Carousel';
import { ProductListerTile } from '../product-lister/ProductListerTile';
const TEST_ID = 'product-group';
export const ProductGroupCarousel = ({ productGroupId, productGroup, title, link }) => {
    var _a;
    const dispatch = useDispatch();
    useEffect(() => {
        var _a;
        if (productGroupId && ((_a = productGroup === null || productGroup === void 0 ? void 0 : productGroup[productGroupId]) === null || _a === void 0 ? void 0 : _a.length)) {
            dispatch(productGroupActions.init());
        }
    }, [dispatch, productGroupId, productGroup]);
    if (!productGroupId || !((_a = productGroup === null || productGroup === void 0 ? void 0 : productGroup[productGroupId]) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    const handleClickWishlist = (product, activeColour, activeSize) => dispatch(wishListActions.toggleProduct({
        productCode: product.productCode,
        productId: product.productId,
        colorId: activeColour.colourId,
        sku: activeSize === null || activeSize === void 0 ? void 0 : activeSize.sku,
    }));
    const handleClickCompare = (product, activeColour, productURL) => dispatch(compareActions.createUpdateOnListerAction({
        brand: product.brand,
        color: activeColour.colourId,
        image: activeColour.image,
        productCode: product.productCode,
        selected: false,
        id: product.productId,
        title: product.title,
        gender: product.genderCode,
        url: productURL,
        colorDescription: activeColour.description,
        collapsedComparePopup: true,
    }));
    const renderSlide = (slide, index) => (_jsx(CarouselSlot, { children: _jsx(ProductListerTile, { product: slide, position: index + 1, onClickWishlist: handleClickWishlist, onClickCompare: handleClickCompare }) }, `product_group_tile_${index}`));
    return (_jsxs(Stack, { testId: TEST_ID, direction: "col", gap: "4", children: [_jsxs(ConditionalWrapper, { condition: !!title && !!link, wrapper: children => (_jsx(Stack, { justify: "between", gap: "2", align: "baseline", wrap: "wrap", children: children })), children: [title && (_jsx(TextAlpha, { as: "h2", variant: "headingM", whiteSpace: "nowrap", children: title })), link] }), _jsx(Carousel, { testId: generateTestId({ testId: TEST_ID, suffix: 'carousel' }), slideSize: {
                    xs: getSlideSizeWithGap(2),
                    md: getSlideSizeWithGap(3),
                    lg: getSlideSizeWithGap(4),
                    xl: getSlideSizeWithGap(5),
                }, slideHeight: "auto", children: _jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(CarouselContent, { children: productGroup[productGroupId].map(renderSlide) }), _jsxs(Stack, { wrap: "nowrap", justify: "between", align: "center", gap: "1", children: [_jsx(CarouselSlidePagination, {}), _jsxs(Stack, { wrap: "nowrap", gap: "1", children: [_jsx(CarouselPrevious, {}), _jsx(CarouselNext, {})] })] })] }) })] }));
};
